import React from 'react';
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from 'react-stripe-elements';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import swal from 'sweetalert';

import * as billingActions from '../../redux/billing';
import forwardArrowButton from '../../svg/forward-arrow-button.svg';

interface Props {
  desktop: boolean;
  stripe?: any;
  billing: any;
}
interface State {
  adding: boolean;
  ready: boolean;
  status: Array<boolean>;
}

class CardForm extends React.Component<Props, State> {
  height = window.innerHeight;
  state: State = {
    adding: false,
    ready: false,
    status: [false, false, false],
  };

  updateStatus(i: number, state: boolean) {
    const a = this.state.status;
    a[i] = state;
    this.setState({ status: a });
  }

  ready(event: any) {
    this.setState({ ready: event.complete });
  }

  handleError() {
    swal('The card information is incorrect!');
    this.setState({ ready: false, adding: false });
  }

  handleSubmit(ev: any) {
    ev.preventDefault();

    this.setState({ adding: true });
    this.props.stripe
      .createToken({})
      .then((data: any) => {
        this.props.billing.addCard(data.token.id).catch((error: any) => this.handleError());
      })
      .catch((error: any) => {
        this.handleError();
      });
  }

  render() {
    return (
      <div>
        <form onSubmit={(e) => this.handleSubmit(e)}>
          <div className="card-row">
            <div style={{ margin: 'auto', width: '180px' }}>
              <div style={{ border: '3px solid #ccc', padding: '5px', width: '180px' }}>
                <CardNumberElement onChange={(o) => this.updateStatus(0, o.complete)} />
              </div>
              <div className="row" style={{ marginTop: '20px' }}>
                <div className="col">
                  <div style={{ border: '3px solid #ccc', padding: '5px', width: '75px' }}>
                    <CardExpiryElement onChange={(o) => this.updateStatus(1, o.complete)} />
                  </div>
                </div>
                <div className="col">
                  <div style={{ border: '3px solid #ccc', padding: '5px', width: '50px' }}>
                    <CardCVCElement onChange={(o) => this.updateStatus(2, o.complete)} />
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          <button
            className={this.props.desktop ? 'selectPlanButtonDesktop' : 'selectPlanButton'}
            style={
              {
                opacity: this.state.status.every((x) => x) ? '1' : '0.4',
                top: this.height - 58 + 'px',
              } as any
            }
            type="submit"
          >
            {this.state.adding ? (
              'ADDING CARD...'
            ) : (
              <div>
                SAVE + CONTINUE <img src={forwardArrowButton} />
              </div>
            )}
          </button>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    customer: state.billing.customer,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    billing: bindActionCreators(billingActions, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectStripe(CardForm));
